import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import Actions from './actions';
var Types = Actions.Types;
var INITIAL_STATE = {
  isLoading: false,
  isValidatingOrder: false,
  foodBasketId: null,
  cateringBasketId: null,
  giftCardInfo: [],
  destructuredCart: {},
  paypal: null,
  isPaypal: false,
  savedPromos: [],
  upsellInfo: {},
  isRetail: false,
  price: {},
  isTokenExEnabled: false,
  cartBeforeRewards: {},
  rewardsCartAction: null,
  GiftCardDetails: null
};

var cartReducer = function cartReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case Types.REQUEST:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: true
        });
      }

    case Types.RESPONSE:
      {
        var cart = action.cart,
            price = action.price,
            isCatering = action.isCatering,
            isFood = action.isFood,
            isRetail = action.isRetail,
            food = action.food,
            cater = action.cater,
            destructuredCart = action.destructuredCart,
            displayErrors = action.displayErrors,
            isTokenExEnabled = action.isTokenExEnabled,
            GiftCardDetails = action.GiftCardDetails;
        return _objectSpread(_objectSpread({}, state), {}, {
          cart: cart,
          displayErrors: displayErrors,
          price: price,
          destructuredCart: destructuredCart,
          isCatering: isCatering,
          isFood: isFood,
          isRetail: isRetail,
          food: food,
          cater: cater,
          isLoading: false,
          leadtimeErr: "",
          isTokenExEnabled: isTokenExEnabled ? isTokenExEnabled : state.IsTokenExEnabled,
          rewardsApplied: false,
          cartBeforeRewards: {
            cart_org: _toConsumableArray(cart),
            destructuredCart: _objectSpread({}, destructuredCart),
            price: _objectSpread({}, price)
          },
          GiftCardDetails: GiftCardDetails
        });
      }

    case Types.TOKEN_EX_GET_AUTH_KEY:
      {
        var error = action.error,
            authenticationKey = action.authenticationKey,
            tokenScheme = action.tokenScheme,
            timestamp = action.timestamp,
            origin = action.origin;
        return _objectSpread(_objectSpread({}, state), {}, {
          tokenExError: error,
          tokenExTokenScheme: tokenScheme,
          tokenExTimestamp: timestamp,
          tokenExAuthenticationKey: authenticationKey,
          tokenExOrigin: origin
        });
      }

    case Types.POST:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: true
        });
      }

    case Types.POST_ITEM:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: true
        });
      }

    case Types.POST_ITEM_RECEIVE:
      {
        var newItem = action.newItem,
            cateringBasketId = action.cateringBasketId,
            foodBasketId = action.foodBasketId,
            upsellInfo = action.upsellInfo;
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: false,
          addedToCart: true,
          saveForEdit: undefined,
          foodBasketId: foodBasketId,
          cateringBasketId: cateringBasketId,
          newItem: newItem,
          upsellInfo: upsellInfo,
          leadtimeErr: "",
          rewardsCartAction: "add"
        });
      }

    case Types.PATCH_ITEM:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: true,
          rewardsCartAction: "patch"
        });
      }

    case Types.CLOSE_ADD_TO:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          addedToCart: false
        });
      }

    case Types.DELETE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: true,
          rewardsCartAction: "delete"
        });
      }

    case Types.REQUEST_DELIVERY_MODE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isDeliveryModeGetting: true
        });
      }

    case Types.RECIEVE_DELIVERY_MODE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isDeliveryModeGetting: false
        });
      }

    case Types.REQUEST_TIME_WANTED:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isValidatingTimeWanted: true
        });
      }

    case Types.RECIEVE_TIME_WANTED:
      {
        var timeWanted = action.timeWanted;
        return _objectSpread(_objectSpread({}, state), {}, {
          timeWanted: timeWanted,
          isValidatingTimeWanted: false,
          goToCheckout: true
        });
      }

    case Types.RESET_LOADING:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isValidatingTimeWanted: false,
          isSendingPromoCode: false,
          isSubmittingCart: false,
          isValidatingOrder: false
        });
      }

    case Types.SET_IS_LOADING:
      {
        var isLoading = action.isLoading; // console.log('ARE WE LOADING',isLoading)

        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: isLoading
        });
      }

    case Types.REQUEST_DELIVERY_INFO:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isValidating: true,
          deliveryFail: false
        });
      }

    case Types.REQUEST_DELIVERY_INFO_FAIL:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isValidating: false,
          deliveryFail: true,
          isDeliveryModeGetting: false
        });
      }

    case Types.RECIEVE_DELIVERY_INFO:
      {
        var deliveryInfo = action.deliveryInfo;
        return _objectSpread(_objectSpread({}, state), {}, {
          deliveryInfo: deliveryInfo,
          isValidating: false
        });
      }

    case Types.REQUEST_SUBMIT_CART:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isSubmittingCart: true,
          validateSuccess: false
        });
      }

    case Types.RECIEVE_SUBMIT_CART:
      {
        var submitInfo = action.submitInfo,
            paymentInfo = action.paymentInfo;
        return _objectSpread(_objectSpread({}, state), {}, {
          checkoutSuccess: true,
          isSubmittingCart: false,
          submitInfo: submitInfo,
          paymentInfo: paymentInfo
        });
      }

    case Types.CLOSE_CHECKOUT:
      {
        //Fresh State
        return _objectSpread({}, INITIAL_STATE);
      }

    case Types.SET_GO_TO_CHECKOUT:
      {
        var goToCheckout = action.goToCheckout;
        return _objectSpread(_objectSpread({}, state), {}, {
          goToCheckout: goToCheckout
        });
      }

    case Types.SAVE_FOR_EDIT:
      {
        var saveForEdit = action.saveForEdit;
        return _objectSpread(_objectSpread({}, state), {}, {
          saveForEdit: saveForEdit
        });
      }

    case Types.RESET_SAVE_FOR_EDIT:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          saveForEdit: null
        });
      }

    case Types.REQUEST_POST_TIP:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isPostingTip: true
        });
      }

    case Types.RECIEVE_POST_TIP:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isPostingTip: false
        });
      }

    case Types.REQUEST_DELIVERY_MODE_OPTIONS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isGettingDeliveryModes: true
        });
      }

    case Types.RECIEVE_DELIVERY_MODE_OPTIONS:
      {
        var deliveryModes = action.deliveryModes;
        return _objectSpread(_objectSpread({}, state), {}, {
          isGettingDeliveryModes: false,
          deliveryModes: deliveryModes
        });
      }

    case Types.REQUEST_CURBSIDE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isSendingCurbside: true
        });
      }

    case Types.RECIEVE_CURBSIDE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isSendingCurbside: false
        });
      }

    case Types.REQUEST_PROMO_CODE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isSendingPromoCode: true
        });
      }

    case Types.RECIEVE_PROMO_CODE:
      {
        var newCode = action.newCode;
        var statePromo = Array.isArray(state.savedPromos) ? state.savedPromos : [];
        var savedPromos = [newCode].concat(_toConsumableArray(statePromo));
        return _objectSpread(_objectSpread({}, state), {}, {
          isSendingPromoCode: false,
          savedPromos: savedPromos
        });
      }

    case Types.REMOVE_PROMO_CODE:
      {
        var removeCode = action.removeCode;

        var _statePromo = Array.isArray(state.savedPromos) ? state.savedPromos : [];

        var _savedPromos = _statePromo.filter(function (e) {
          return e !== removeCode;
        });

        return _objectSpread(_objectSpread({}, state), {}, {
          isSendingPromoCode: false,
          savedPromos: _savedPromos
        });
      }

    case Types.SET_DELIVERY_MODE:
      {
        var deliveryMode = action.deliveryMode;
        return _objectSpread(_objectSpread({}, state), {}, {
          deliveryMode: deliveryMode
        });
      }

    case Types.SET_SHIPPING_MODE:
      {
        var shippingMode = action.shippingMode;
        console.log('Store Shipping Mode: ', shippingMode, action);
        return _objectSpread(_objectSpread({}, state), {}, {
          shippingMode: shippingMode
        });
      }

    case Types.REQUEST_VALIDATE_CART:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          validateSuccess: false,
          isValidatingOrder: true
        });
      }

    case Types.RECIEVE_VALIDATE_CART:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          validateSuccess: true,
          isValidatingOrder: false
        });
      }

    case Types.HIDE_VALIDATE_CART:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          validateSuccess: false,
          isValidatingOrder: false
        });
      }

    case Types.REQUEST_CLEAR_CART:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          clearSuccess: false
        });
      }

    case Types.RECIEVE_CLEAR_CART:
      {
        return {
          clearSuccess: true
        };
      }

    case Types.REQUEST_GIFT_CARD:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          giftCardGet: true
        });
      }

    case Types.RECIEVE_GIFT_CARD:
      {
        var giftCardInfo = action.giftCardInfo,
            _price = action.price;
        return _objectSpread(_objectSpread({}, state), {}, {
          giftCardGet: false,
          giftCardInfo: giftCardInfo,
          price: _price,
          cartBeforeRewards: _objectSpread(_objectSpread({}, state.cartBeforeRewards), {}, {
            price: _objectSpread({}, _price)
          })
        });
      }

    case Types.REQUEST_GIFT_CARD_SCHEME:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          giftCardGetScheme: true
        });
      }

    case Types.RECIEVE_GIFT_CARD_SCHEME:
      {
        var giftCardScheme = action.giftCardScheme,
            ccScheme = action.ccScheme,
            applePayScheme = action.applePayScheme,
            googlePayScheme = action.googlePayScheme;
        return _objectSpread(_objectSpread({}, state), {}, {
          giftCardGetScheme: false,
          giftCardScheme: giftCardScheme,
          ccScheme: ccScheme,
          applePayScheme: applePayScheme,
          googlePayScheme: googlePayScheme
        });
      }

    case Types.CLEAR_STATES:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          validateSuccess: false,
          checkoutSuccess: false,
          isPaypal: false,
          isValidatingOrder: false
        });
      }

    case Types.REQUEST_SHIPPING_MODES:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          getShippingModes: true
        });
      }

    case Types.RECIEVE_SHIPPING_MODES:
      {
        var shippingModes = action.shippingModes;
        return _objectSpread(_objectSpread({}, state), {}, {
          getShippingModes: false,
          shippingModes: shippingModes
        });
      }

    case Types.RECIEVE_SAVED_CARDS:
      {
        var savedCards = action.savedCards;
        return _objectSpread(_objectSpread({}, state), {}, {
          savedCards: savedCards
        });
      }

    case Types.REQUEST_PAYPAL_ORDER:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: true
        });
      }

    case Types.SET_PAYPAL_ORDER:
      {
        var paypal = action.paypal;
        return _objectSpread(_objectSpread({}, state), {}, {
          isPaypal: true,
          paypal: paypal,
          isLoading: false
        });
      }

    case Types.RESET_PAYPAL_ORDER:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: false
        });
      }

    case Types.NEWS_LETTER_REQUEST:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: true
        });
      }

    case Types.NEWS_LETTER_RESPONSE:
      {
        var results = action.results;
        return _objectSpread(_objectSpread({}, state), {}, {
          results: results,
          isLoading: false
        });
      }

    case Types.RECIVE_LEADTIME_ERR:
      {
        var leadtimeErr = action.leadtimeErr;
        return _objectSpread(_objectSpread({}, state), {}, {
          leadtimeErr: leadtimeErr,
          isLoading: false
        });
      }

    case Types.SET_LOYALTY_DATA:
      {
        var loyaltyData = action.loyaltyData;
        return _objectSpread(_objectSpread({}, state), {}, {
          loyaltyData: loyaltyData
        });
      }

    case Types.REDEEM_REWARDS_ACTION:
      {
        var _cart = action.cart,
            rewardsApplied = action.rewardsApplied;
        return _objectSpread(_objectSpread({}, state), {}, {
          cart: _toConsumableArray(_cart.cart),
          destructuredCart: _objectSpread({}, _cart.destructuredCart),
          isLoading: false,
          rewardsApplied: rewardsApplied
        });
      }

    case Types.UPDATE_REWARDS_APPLIED_FLAG:
      {
        var _rewardsApplied = action.rewardsApplied;
        return _objectSpread(_objectSpread({}, state), {}, {
          rewardsApplied: _rewardsApplied
        });
      }

    case Types.RESET_REWARDS_CART_ACTION:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          rewardsCartAction: null
        });
      }

    default:
      {
        return state;
      }
  }
};

export default cartReducer;